// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/Users/microcipcip/works/domains/microcipcip.digital/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/Users/microcipcip/works/domains/microcipcip.digital/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/microcipcip/works/domains/microcipcip.digital/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/Users/microcipcip/works/domains/microcipcip.digital/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/Users/microcipcip/works/domains/microcipcip.digital/.cache/json/index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/Users/microcipcip/works/domains/microcipcip.digital/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/Users/microcipcip/works/domains/microcipcip.digital/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js